import { useQuery } from "react-query";

import http from "../../services/httpService";
import Util from "../../util/util";
import useLeague from "../queryResults/useLeague";
import useLeagueSeason from "../queryResults/useLeagueSeason";
import useUrls from "../useUrls";

const getGames = (league, leagueSeason, apiUrl, week) => async () => {
  console.log("getGames() called...");

  const config = Util.addTokenToHeaders();
  let url = `${apiUrl}/leagues/${league.getIdOrSlug()}/${
    leagueSeason.obj.season
  }/games`;

  if (week) url += "/week/" + week;

  const { data } = await http.get(url, config);

  console.log("getGames() response data:");
  console.log(data);

  return data;
};

export default function useQueryGames(week) {
  const { league } = useLeague();
  const { leagueSeason } = useLeagueSeason();
  const { apiUrl } = useUrls();

  return useQuery(
    ["games", leagueSeason?.obj?.id, week],
    getGames(league, leagueSeason, apiUrl, week),
    {
      enabled: !!league && !!leagueSeason,
    }
  );
}
